define('modules/editor/views/editors/image_upload',['require','exports','module','fineuploader','common/views/modal_view','env','services/auth','ldsh!../../templates/editors/image_upload'],function (require, exports, module) {
  'use strict';
  require('fineuploader');
  var ModalView = require('common/views/modal_view'),
    config = require('env'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo();

  module.exports = ModalView.extend({
    template: require('ldsh!../../templates/editors/image_upload'),

    //className: "modal fade",
    events: {
      'shown.bs.modal': 'onModalShown',
      'click .js-upload': 'uploadFile',
      'change .js-optimize': 'setOptimizationParam',
    },

    initialize: function (options) {
      this.options = options;
      if (!this.options.pages_id) {
        throw new Error('Need pageId to upload images');
      }
      if (!this.options.variants_id) {
        this.options.variants_id = 'main';
      }
      this.viewModel = new Backbone.Model({
        optimize: true,
      });
    },

    setOptimizationParam: function (e) {
      this.viewModel.set('optimize', this.$('.js-optimize').is(':checked'), {
        silent: true,
      });
    },

    uploadFile: function (e) {
      var params = _.extend(this.options, {
        optimize: this.viewModel.get('optimize'),
      });
      this.$('#fileUploader').fineUploader('setParams', params);
      this.$('#fileUploader').fineUploader('uploadStoredFiles');
    },

    onRender: function () {
      this.$el.i18n();
    },

    onModalShown: function () {
      this._setupUploader();
    },

    onSaveError: function (e, id, name, errorReason, jqXHR) {
      //remove filename because it's lost after an error
      this.$('.js-filename').val('');
      //remove thumbnail
      this.$('#js-preview').attr('src', '');

      //show error message
      if (this.$('.js-error[data-error="' + errorReason + '"]').length) {
        this.$('.js-error[data-error="' + errorReason + '"]').slideDown();
      } else {
        this.$('.js-error').slideDown();
      }

      //remove preview
      this.$('#js-preview').empty();
    },

    onSaveComplete: function (e, id, name, response) {
      var data = {
        url: response.hash,
        id: response.id,
      };
      if (response.success) {
        this.trigger('modal:save', data);
      }
    },

    _setupUploader: function () {
      var self = this;
      var uploaderParams = {
        autoUpload: false,
        uploaderType: 'basic',
        button: this.$('.js-browse'),
        request: {
          endpoint: config.apiHost + '/images',
          customHeaders: {
            Authorization: 'Bearer ' + authInfo.getAccessToken(),
          },
          params: {
            pages_id: this.options.pages_id,
            variants_id: this.options.variants_id,
            platform: this.options.platform,
          },
        },
        cors: {
          allowXdr: true,
          expected: true,
        },
        validation: {
          acceptFiles: '.jpg,.jpeg,.png,.gif,.svg',
          allowedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'svg'],
        },
      };

      this.uploader = this.$('#fileUploader')
        .fineUploader(uploaderParams)
        .on('submit', function (e, id, name) {
          //show name on input
          self.$('.js-filename').val(name);
          //remove error if visible
          self.$('.js-error').hide();

          var size = $(this).fineUploader('getSize', id);
          if (size > config.maxImageSizeToUpload) {
            self.onSaveError(null, id, name, 'errorMaxFileSizeExceeded');
            return;
          }

          //draw thumbnail
          $(this).fineUploader(
            'drawThumbnail',
            id,
            self.$('#js-preview'),
            300,
            false
          );
        })
        .on('complete', _.bind(self.onSaveComplete, self))
        .on('error', _.bind(self.onSaveError, self));
    },
  });
});

